import { render, staticRenderFns } from "./BoardSettingsDelete.vue?vue&type=template&id=1367d0c8&scoped=true&lang=pug&"
import script from "./BoardSettingsDelete.vue?vue&type=script&lang=js&"
export * from "./BoardSettingsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1367d0c8",
  null
  
)

export default component.exports